import {LngLat} from '../../types'

export const getGeolocationFromBrowser = (): Promise<LngLat> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(({coords}) => resolve([coords.longitude, coords.latitude]), reject, {
      enableHighAccuracy: true,
      maximumAge: 60000,
      timeout: 10000,
    })
  })

export const getGeolocationPermission = (): Promise<PermissionStatus> => {
  if (!navigator.permissions) {
    return Promise.reject()
  }

  return new Promise((resolve, reject) => {
    navigator.permissions.query({name: 'geolocation'}).then(resolve).catch(reject)
  })
}
